import BrowserSupport from './assets/browser-support.js';
BrowserSupport.isIE10();

import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import VueClipboard from 'vue-clipboard2';
import VTooltip from 'v-tooltip';
import './styles/app.scss';

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(VTooltip);
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'main',
    },
  ],
});

Vue.use(VueGtag, {
  config:{
    id: 'UA-860026-1',
    appName: 'ohr-residency-waiver',
    pageTrackerScreenviewEnabled: true,
    params: {},
  },
}, router);

new Vue({
  el: '#vue-app',
  router,
  render (h) {
    return h(App, {});
  },
});
